module.exports = "/images/content-img-2.jpg?00ef7d9734606af4e586bf6e2f2239e8";